import React from "react";
import { HomeListLoaderTemplate } from "themes/application/home/components";

function HomeListLoader(props) {
    return <HomeListLoaderTemplate {...props} />;
}

export default HomeListLoader;
